import React, { useEffect, useState } from 'react';
import { Menu, X, ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [platformDropdownOpen, setPlatformDropdownOpen] = useState(false);
  const [companyDropdownOpen, setCompanyDropdownOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navItems = ['Contact'];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/95 backdrop-blur-sm shadow-sm border-b border-line py-3' : 'bg-white border-b border-line py-4'}`} data-id="element-1167">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1168">
        <div className="flex justify-between items-center" data-id="element-1169">
          {/* Logo Area */}
          <div className="flex items-baseline gap-3" data-id="element-1170">
            <a href="#home" className="text-2xl font-heading font-bold text-navy tracking-tight" data-id="element-1171">
              SyNeural
            </a>
          </div>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center gap-8" data-id="element-1172">
            <ul className="flex items-center gap-6" data-id="element-1173">
              {/* Platform Dropdown */}
              <li className="relative" data-id="element-1174">
                <button onMouseEnter={() => setPlatformDropdownOpen(true)} onMouseLeave={() => setPlatformDropdownOpen(false)} className="text-sm font-medium text-ink-muted hover:text-navy transition-colors flex items-center gap-1" data-id="element-1175">
                  Platform
                  <ChevronDown size={14} className={`transition-transform ${platformDropdownOpen ? 'rotate-180' : ''}`} data-id="element-1176" />
                </button>

                <AnimatePresence data-id="element-1177">
                  {platformDropdownOpen && <motion.div initial={{
                  opacity: 0,
                  y: -10
                }} animate={{
                  opacity: 1,
                  y: 0
                }} exit={{
                  opacity: 0,
                  y: -10
                }} transition={{
                  duration: 0.2
                }} onMouseEnter={() => setPlatformDropdownOpen(true)} onMouseLeave={() => setPlatformDropdownOpen(false)} className="absolute top-full left-0 mt-2 w-56 bg-white rounded-lg shadow-lg border border-line py-2" data-id="element-1178">
                      <a href="#cji" className="block px-4 py-2 text-sm text-ink-dark hover:bg-surface-muted transition-colors" data-id="element-1179">
                        <div className="font-semibold" data-id="element-1180">CJI</div>
                        <div className="text-xs text-ink-muted" data-id="element-1181">
                          Civic Judgment Index
                        </div>
                      </a>
                      <a href="#ncji" className="block px-4 py-2 text-sm text-ink-dark hover:bg-surface-muted transition-colors" data-id="element-1182">
                        <div className="font-semibold" data-id="element-1183">NCJI</div>
                        <div className="text-xs text-ink-muted" data-id="element-1184">
                          Neurocognitive Index
                        </div>
                      </a>
                      <div className="border-t border-line my-2" data-id="element-1185"></div>
                      <a href="#solutions" className="block px-4 py-2 text-sm text-ink-dark hover:bg-surface-muted transition-colors" data-id="element-1186">
                        <div className="font-semibold" data-id="element-1187">Solutions</div>
                        <div className="text-xs text-ink-muted" data-id="element-1188">
                          Applications & Use Cases
                        </div>
                      </a>
                    </motion.div>}
                </AnimatePresence>
              </li>

              {/* Company Dropdown */}
              <li className="relative" data-id="element-1189">
                <button onMouseEnter={() => setCompanyDropdownOpen(true)} onMouseLeave={() => setCompanyDropdownOpen(false)} className="text-sm font-medium text-ink-muted hover:text-navy transition-colors flex items-center gap-1" data-id="element-1190">
                  Company
                  <ChevronDown size={14} className={`transition-transform ${companyDropdownOpen ? 'rotate-180' : ''}`} data-id="element-1191" />
                </button>

                <AnimatePresence data-id="element-1192">
                  {companyDropdownOpen && <motion.div initial={{
                  opacity: 0,
                  y: -10
                }} animate={{
                  opacity: 1,
                  y: 0
                }} exit={{
                  opacity: 0,
                  y: -10
                }} transition={{
                  duration: 0.2
                }} onMouseEnter={() => setCompanyDropdownOpen(true)} onMouseLeave={() => setCompanyDropdownOpen(false)} className="absolute top-full left-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-line py-2" data-id="element-1193">
                      <a href="#about" className="block px-4 py-2 text-sm text-ink-dark hover:bg-surface-muted transition-colors" data-id="element-1194">
                        <div className="font-semibold" data-id="element-1195">About</div>
                        <div className="text-xs text-ink-muted" data-id="element-1196">
                          Mission & Vision
                        </div>
                      </a>
                      <a href="#research" className="block px-4 py-2 text-sm text-ink-dark hover:bg-surface-muted transition-colors" data-id="element-1197">
                        <div className="font-semibold" data-id="element-1198">Research</div>
                        <div className="text-xs text-ink-muted" data-id="element-1199">
                          Future Work
                        </div>
                      </a>
                      <a href="#partnerships" className="block px-4 py-2 text-sm text-ink-dark hover:bg-surface-muted transition-colors" data-id="element-1200">
                        <div className="font-semibold" data-id="element-1201">Partnerships</div>
                        <div className="text-xs text-ink-muted" data-id="element-1202">
                          Collaborate with Us
                        </div>
                      </a>
                    </motion.div>}
                </AnimatePresence>
              </li>

              {navItems.map(item => <li key={item} data-id="element-1203">
                  <a href={`#${item.toLowerCase()}`} className="text-sm font-medium text-ink-muted hover:text-navy transition-colors" data-id="element-1204">
                    {item}
                  </a>
                </li>)}
            </ul>
            <div className="w-px h-5 bg-line" data-id="element-1205"></div>
            <button className="bg-navy hover:bg-navy-light text-white text-sm font-medium px-5 py-2.5 rounded-md transition-colors shadow-sm" data-id="element-1206">
              Request Demo
            </button>
          </nav>

          {/* Mobile Menu Toggle */}
          <button className="lg:hidden text-ink-dark p-2" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Toggle menu" data-id="element-1207">
            {mobileMenuOpen ? <X size={24} data-id="element-1208" /> : <Menu size={24} data-id="element-1209" />}
          </button>
        </div>
      </div>

      {/* Mobile Nav Drawer */}
      <AnimatePresence data-id="element-1210">
        {mobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="lg:hidden bg-white border-b border-line overflow-hidden" data-id="element-1211">
            <div className="px-4 pt-2 pb-6 space-y-1 shadow-inner" data-id="element-1212">
              {/* Platform submenu */}
              <div className="border-b border-line pb-2 mb-2" data-id="element-1213">
                <div className="text-xs font-semibold text-ink-muted uppercase tracking-wider px-3 py-2" data-id="element-1214">
                  Platform
                </div>
                <a href="#cji" className="block px-3 py-2 text-base font-medium text-ink-dark hover:bg-surface-muted rounded-md" onClick={() => setMobileMenuOpen(false)} data-id="element-1215">
                  CJI
                </a>
                <a href="#ncji" className="block px-3 py-2 text-base font-medium text-ink-dark hover:bg-surface-muted rounded-md" onClick={() => setMobileMenuOpen(false)} data-id="element-1216">
                  NCJI
                </a>
                <a href="#solutions" className="block px-3 py-2 text-base font-medium text-ink-dark hover:bg-surface-muted rounded-md" onClick={() => setMobileMenuOpen(false)} data-id="element-1217">
                  Solutions
                </a>
              </div>

              {/* Company submenu */}
              <div className="border-b border-line pb-2 mb-2" data-id="element-1218">
                <div className="text-xs font-semibold text-ink-muted uppercase tracking-wider px-3 py-2" data-id="element-1219">
                  Company
                </div>
                <a href="#about" className="block px-3 py-2 text-base font-medium text-ink-dark hover:bg-surface-muted rounded-md" onClick={() => setMobileMenuOpen(false)} data-id="element-1220">
                  About
                </a>
                <a href="#research" className="block px-3 py-2 text-base font-medium text-ink-dark hover:bg-surface-muted rounded-md" onClick={() => setMobileMenuOpen(false)} data-id="element-1221">
                  Research
                </a>
                <a href="#partnerships" className="block px-3 py-2 text-base font-medium text-ink-dark hover:bg-surface-muted rounded-md" onClick={() => setMobileMenuOpen(false)} data-id="element-1222">
                  Partnerships
                </a>
              </div>

              {navItems.map(item => <a key={item} href={`#${item.toLowerCase()}`} className="block px-3 py-3 text-base font-medium text-ink-dark hover:bg-surface-muted rounded-md" onClick={() => setMobileMenuOpen(false)} data-id="element-1223">
                  {item}
                </a>)}
              <div className="pt-4 px-3" data-id="element-1224">
                <button className="w-full bg-navy text-white font-medium px-5 py-3 rounded-md shadow-sm" data-id="element-1225">
                  Request Demo
                </button>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}